// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"b85d8bf2","977":"69db5f03"}[chunkId] + ".chunk.js";
};